export enum FieldType {
  ADDRESS = 'ADDRESS',
  ACCOUNTNUMBER = 'ACCOUNTNUMBER',
  CHECKBOX = 'CHECKBOX',
  CHECKBOXGROUP = 'CHECKBOXGROUP',
  CVR = 'CVR',
  EMAIL = 'EMAIL',
  INVOICENUMBER = 'INVOICENUMBER',
  MESSAGE = 'MESSAGE',
  NAME = 'NAME',
  NUMBER = 'NUMBER',
  PASSWORD = 'PASSWORD',
  PHONE_DK = 'PHONE_DK',
  PHONE_INTERNATIONAL = 'PHONE_INTERNATIONAL',
  RADIO = 'RADIO',
  SELECT = 'SELECT',
  SWITCH = 'SWITCH',
  TEXT = 'TEXT',
  RADIOBUTTONGROUP = 'RADIOBUTTONGROUP',
  DATEPICKER = 'DATEPICKER',
  TIMEPICKER = 'TIMEPICKER',
  FILEUPLOAD = 'FILEUPLOAD',
  DIVIDER = 'DIVIDER',
  HIDDEN = 'HIDDEN',
  FAKTURA_KONTONUMMER = 'FAKTURA_KONTONUMMER',
}
